export default {
  'pages.platformSettings.title': '平台設定',
  'pages.platformSettings.tab.branding': '品牌',
  'pages.platformSettings.tab.llm': '預設大模型',
  'pages.platformSettings.tab.storage': '預設儲存',
  'pages.platformSettings.tab.quota': '用量限制',
  'pages.platformSettings.tab.features': '平台功能',
  'pages.platformSettings.tab.permissions': '平台權限',
  'pages.platformSettings.subtitle.branding':
    '設定珊瑚礁平台的名稱、Logo 與版權資訊。',
  'pages.platformSettings.subtitle.llm': '設定平台預設使用的大模型。',
  'pages.platformSettings.subtitle.storage': '設定新建應用時的預設儲存策略。',
  'pages.platformSettings.subtitle.quota':
    '設定對所有租戶生效的預設額度與上限。',
  'pages.platformSettings.subtitle.features': '開啟或關閉平台級功能。',
  'pages.platformSettings.subtitle.permissions':
    '按帳號授予平台級角色，租戶內不再單獨設定角色。',
  'pages.platformSettings.save': '儲存',
  'pages.platformSettings.reset': '重設',
  'pages.platformSettings.saveSuccess': '設定已儲存',
  'pages.platformSettings.saveFailed': '儲存失敗，請重試',
  'pages.platformSettings.loadFailed': '平台設定載入失敗',
  'pages.platformSettings.retry': '重試',
  'pages.platformSettings.zeroUnlimited': '填 0 表示不限制',
  'pages.platformSettings.branding.title': '平台品牌',
  'pages.platformSettings.branding.description':
    '品牌資訊對所有使用者生效，包括登入前頁面。名稱與 Logo 預設顯示目前部署使用的值；底部版權留空時沿用各語言的預設設定。',
  'pages.platformSettings.branding.platformName': '平台名稱',
  'pages.platformSettings.branding.platformNameExtra':
    '顯示在頂欄與瀏覽器標題中',
  'pages.platformSettings.branding.platformNamePlaceholder': '例如：珊瑚礁',
  'pages.platformSettings.branding.platformNameEn': '英文名稱',
  'pages.platformSettings.branding.logoLight': '淺色主題 Logo',
  'pages.platformSettings.branding.logoDark': '深色主題 Logo',
  'pages.platformSettings.branding.favicon': '瀏覽器分頁圖示',
  'pages.platformSettings.branding.footerCopyright': '底部版權資訊',
  'pages.platformSettings.branding.logoHint':
    '支援 PNG、JPG、SVG、WebP、ICO，不超過 5MB',
  'pages.platformSettings.branding.uploadFailed': '上傳失敗，請重試',
  'pages.platformSettings.branding.upload': '上傳',
  'pages.platformSettings.branding.restoreDefault': '恢復預設',
  'pages.platformSettings.llm.title': '平台預設大模型',
  'pages.platformSettings.llm.description':
    '未單獨指定模型的租戶與業務應用將使用這裡的預設模型。可選項來自「模型廣場」中已啟用的平台內建模型。',
  'pages.platformSettings.llm.manageModels': '管理模型',
  'pages.platformSettings.llm.loadFailed':
    '模型目錄載入失敗，僅顯示已儲存的選擇',
  'pages.platformSettings.llm.chatModel': '預設對話模型',
  'pages.platformSettings.llm.embeddingModel': '預設向量模型',
  'pages.platformSettings.llm.notSet': '未設定',
  'pages.platformSettings.llm.unavailableModel': '{ref}（已停用或不存在）',
  'pages.platformSettings.storage.title': '平台預設儲存',
  'pages.platformSettings.storage.description':
    '新建業務應用時按以下預設值建立應用儲存設定，既有設定不受影響，可在「應用儲存設定」中單獨調整。',
  'pages.platformSettings.storage.autoProvision': '新建應用時自動建立儲存',
  'pages.platformSettings.storage.autoProvisionExtra':
    '關閉後需在「應用儲存設定」中手動建立',
  'pages.platformSettings.storage.accessMode': '預設存取模式',
  'pages.platformSettings.storage.accessMode.private': '私有',
  'pages.platformSettings.storage.accessMode.public_read': '公共讀',
  'pages.platformSettings.storage.accessMode.public_folder_only':
    '僅公共目錄可讀',
  'pages.platformSettings.storage.usageEnabled': '預設開啟用量統計',
  'pages.platformSettings.quota.title': '租戶用量限制',
  'pages.platformSettings.quota.description':
    '對所有租戶生效的平台級預設限制。方案與加購資源包發放的額度會在預設額度之上累加。',
  'pages.platformSettings.quota.defaultTenantTokenQuota': '租戶預設 Token 額度',
  'pages.platformSettings.quota.defaultTenantStorageQuotaGb':
    '租戶預設儲存額度',
  'pages.platformSettings.quota.maxMembersPerTenant': '單租戶成員數上限',
  'pages.platformSettings.quota.maxInstalledAppsPerTenant':
    '單租戶自助開通應用數上限',
  'pages.platformSettings.quota.defaultQuotaExtra':
    '尚未分配額度的租戶首次使用時按此額度起步；填 0 表示不發放預設額度',
  'pages.platformSettings.quota.maxInstalledAppsExtra':
    '只統計租戶在應用市場自助開通的免費應用，不含方案預設應用；填 0 表示不限制',
  'pages.platformSettings.quota.unitPerson': '人',
  'pages.platformSettings.quota.unitApp': '個',
  'pages.platformSettings.features.title': '平台功能',
  'pages.platformSettings.features.aiAssistant': '全域 AI 助手',
  'pages.platformSettings.features.aiAssistantExtra':
    '關閉後所有使用者頁面右下角不再顯示 AI 助手',
  'pages.platformSettings.permissions.user': '帳號',
  'pages.platformSettings.permissions.grantedAt': '授權時間',
  'pages.platformSettings.permissions.actions': '操作',
  'pages.platformSettings.permissions.revoke': '撤銷',
  'pages.platformSettings.permissions.userRequired': '請選擇帳號',
  'pages.platformSettings.permissions.userPlaceholder':
    '搜尋姓名、使用者名稱、手機號或信箱',
  'pages.platformSettings.readOnlyHint': '你只有檢視權限，不能修改平台設定',
  'pages.platformSettings.permissions.notice':
    '權限按「資源 + 檢視/管理」授予給角色，再把角色授予帳號；與帳號所在租戶無關。角色與授權託管在 YeeAuth，變更最多 30 秒生效。',
  'pages.platformSettings.permissions.roles': '角色',
  'pages.platformSettings.permissions.createRole': '新建角色',
  'pages.platformSettings.permissions.builtin': '內建',
  'pages.platformSettings.permissions.rename': '重新命名',
  'pages.platformSettings.permissions.deleteRole': '刪除',
  'pages.platformSettings.permissions.deleteRoleConfirm':
    '確認刪除角色「{name}」？持有該角色的帳號會失去對應權限。',
  'pages.platformSettings.permissions.deleteRoleSuccess': '角色已刪除',
  'pages.platformSettings.permissions.tabPermissions': '權限',
  'pages.platformSettings.permissions.tabMembers': '成員',
  'pages.platformSettings.permissions.adminLocked':
    '平台管理員擁有全部權限，不能修改',
  'pages.platformSettings.permissions.resource': '資源',
  'pages.platformSettings.permissions.action.read': '檢視',
  'pages.platformSettings.permissions.action.manage': '管理',
  'pages.platformSettings.permissions.roleName': '角色名稱',
  'pages.platformSettings.permissions.roleNameRequired': '請輸入角色名稱',
  'pages.platformSettings.permissions.addMember': '新增成員',
  'pages.platformSettings.permissions.empty': '該角色暫無成員',
  'pages.platformSettings.permissions.revokeConfirm':
    '確認將「{name}」移出{role}？',
  'pages.platformSettings.permissions.cannotRevokeSelf':
    '不能把自己移出平台管理員',
  'pages.platformSettings.permissions.grantSuccess': '已新增成員',
  'pages.platformSettings.permissions.grantFailed': '新增失敗，請重試',
  'pages.platformSettings.permissions.revokeSuccess': '已移出',
  'pages.platformSettings.permissions.loadFailed': '載入失敗',
  'pages.noPlatformPermission.title': '沒有平台權限',
  'pages.noPlatformPermission.description':
    '目前帳號尚未被授予任何珊瑚礁平台角色，請聯絡平台管理員授權後重新登入。',
  'pages.noPlatformPermission.logout': '登出',
  'pages.platformSettings.permissions.group.applications': '應用',
  'pages.platformSettings.permissions.group.commercial': '行銷銷售',
  'pages.platformSettings.permissions.group.capabilities': '基礎服務',
  'pages.platformSettings.permissions.group.resources': '維運監控',
  'pages.platformSettings.permissions.group.management': '平台管理',
  'pages.platformSettings.permissions.group.settings': '設定',
  'pages.platformSettings.storage.accessMode.inherit':
    '沿用檔案管理預設（僅公共目錄可讀）',
};
